<template>
    <div class="cell order-item">
        <div class="order-product grid-x">
            <div class="cell auto order-product-info">
                <div class="grid-x">
                    <div class="align-middle cell flex-container align-justify">
                        <p class="color-dark-gray bold margin-0"><span class="product-qty display-small semi-bold">{{ product.quantity }}</span> {{ product.name }}</p>
                        <p class="color-dark-gray bold margin-0" v-if="product.price">${{ (product.price * (product.quantity ?? 0)).toFixed(2) }}</p>
                    </div>
                    <div class="cell order-product-ingredients">
                        <p class="display-small color-battleship-gray margin-0">{{ productContent }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script lang="ts">
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import Product from '@/models/product';
import Alert from '@/components/common/ui/Alert.vue';
import { AlertType } from '@/utils/types';
import FoodModule from '@/stores/modules/food';
import { getModule } from 'vuex-module-decorators';

@Component({components: {Alert}})
export default class OrderItem extends Vue {
    @Prop(Object) readonly product!: Product;
    foodModule!: FoodModule;

    created() {
        this.foodModule = getModule(FoodModule, this.$store);
    }

    get productContent() {
        return this.product.getContent();
    }

    get AlertType() {
        return AlertType;
    }
}
</script>
<style lang="scss" scoped>
@import '~foundation-sites/scss/foundation';
@import '~scss/front/settings';

.order-product {
    padding-bottom: 15px;

    .product-qty {
        background-color: var(--order-card-product-qty-bg);
        color: var(--order-card-product-qty-color);
        border-radius: 50%;
        width: 24.87px;
        height: 24px;
        line-height: 24px;
        display: inline-block;
        margin-right: 7px;
        text-align: center;
    }
}

.order-product-image {
    height: 72px;
    width: 72px;
    background: var(--light-gray);

    img {
        border-radius: var(--global-radius);
        object-fit: cover;
        height: 100%;
        width: 100%;
    }
}

.order-product-ingredients {
    padding-top: 5px;
}
</style>
